import { IMortgageStep, IProposalInfo } from '../../types/proposal';

export const formatYear = (years: number): string => {
  const arr = ['год', 'года', 'лет'];

  return (
    years + ' ' + arr[years % 100 > 4 && years % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][years % 10 < 5 ? years % 10 : 5]]
  );
};

export function valueToRate(value: number): string {
  const [int, fraction = ''] = (value * 100).toFixed(2).split('.');
  const fractionWithoutZeros = fraction.replace(/0+$/, '');

  const roundedNumber = fractionWithoutZeros === '' ? int : `${int},${fractionWithoutZeros}`;

  return roundedNumber.toString().replace('.', ',');
}

export const prepareSteps = (steps: IMortgageStep[], proposalInfo: IProposalInfo) => {
  return steps.map(step => {
    return {
      ...step,
      description: step.description
        .replace(new RegExp('{mortgageRateDiscount}', 'g'), valueToRate(proposalInfo.mortgageRateDiscount))
        .replace('{discountRateDuration}', formatYear(proposalInfo.discountRateDuration || 0)),
    };
  });
};
